import React from 'react';
import '../App.css';

import { Bitcoin_header, Bitcoin_autores, Bitcoin_descubre, Bitcoin_recomendado, Bitcoin_donde, Bitcoin_grafica, Bitcoin_registro } from '../container';
import { PopupContainer } from "../container/LibroBitcoin/PopupContainer/PopupContainer";
import { PopupProvider } from "../context/PopupProvider";
import { Header_2026, Footer_2026 } from '../container';

const LibroBitcoin = () => {


    return (
        <PopupProvider>
            <div class="App_DB landing_bitcoin_principal">
                <PopupContainer />
                <Header_2026 />
                {/* <Navbar link2='#donde-comprar' />*/}
                <Bitcoin_header />
                <Bitcoin_autores />
                <Bitcoin_descubre />
                <Bitcoin_recomendado />
                <Bitcoin_donde />
                <Bitcoin_registro />
                <Bitcoin_grafica />
                <Footer_2026 />
                {/*<Footer />*/}


            </div>
        </PopupProvider>
    )

}

export default LibroBitcoin;